module.exports = __webpack_public_path__ + "static/media/6.6d1fc8db.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/6.PNG
// module id = 1557
// module chunks = 0